export default __webpack_public_path__ + "static/media/baac.2ddaa76e.svg";